export default "__VITE_ASSET__DUU97F1T__"